import axios from 'axios';
import { getBackOfficeRoute, headers } from './header';
import { ROLE_ADMIN, ROLE_RENTER } from '../../constants/roles';

const RentsApiService = {
  getRents(token, role, limit, page, renters, siteId, longRent) {
    let params = [];
    let stringParam = '';
    if (limit || page) {
      params.push(`limit=${limit}&page=${page}`);
    }
    if (renters && renters.length === 1) {
      params.push(`renterId=${renters[0].id}`);
    }
    if (longRent) {
      params.push(`longRent=1`);
    }
    if (siteId) {
      params.push(`siteId=${siteId}`);
    }
    if (params.length > 0) {
      stringParam = '?' + params.join('&');
    }
    return axios
      .get(`${getBackOfficeRoute(role)}/rents${stringParam}`,
        {
          headers: headers(token),
        },
      )
      .then((response) => response.data);
  },

  getAllUsersByRenter(token) {
    return axios
      .get(`${getBackOfficeRoute(ROLE_RENTER)}/users`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  getAllRentsByUser(token, role, user) {
    return axios
      .get(`${getBackOfficeRoute(role)}/users/${user.id}/rents`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  getCSVRents(token) {
    return axios
      .get(`${getBackOfficeRoute(ROLE_RENTER)}/csv`, {
        headers: {
          ...headers(token),
        },
      })
      .then((response) => response.data);
  },

  postRentsCaution(token, rentID, caution) {
    return axios
      .post(`${getBackOfficeRoute(ROLE_ADMIN)}/rents/${rentID}/caution`, caution, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  putRentEnded(token, rentID, data) {
    return axios
      .put(`${getBackOfficeRoute(ROLE_RENTER)}/rents/${rentID}`, data, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  putCloseRent(token, rentID, data) {
    return axios
      .put(`${getBackOfficeRoute(ROLE_ADMIN)}/rents/${rentID}`, data, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  postRentEndInventory(token, rentId, file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios
      .post(`${getBackOfficeRoute(ROLE_RENTER)}/rents/${rentId}/end-inventory`, formData,{
        headers: {...headers(token), 'Content-Type': 'multipart/form-data'},
      })
      .then((response) => response.data);
  },

  deleteRentEndInventory(token, rentId) {
    return axios
      .delete(`${getBackOfficeRoute(ROLE_RENTER)}/rents/${rentId}/end-inventory`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },
};

export default RentsApiService;



// WEBPACK FOOTER //
// ./src/services/api/RentsApiService.js